var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVersion11 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.4,0H211.6C94.7,0,0,94.7,0,211.6v276.7C0,605.2,94.7,700,211.6,700h276.7C605.2,700,700,605.2,700,488.4V211.6 C700,94.7,605.2,0,488.4,0z M600,448.8c0,83.5-67.7,151.2-151.2,151.2H251.2C167.7,600,100,532.3,100,448.8V251.2 c0-83.5,67.7-151.2,151.2-151.2h197.7c83.5,0,151.2,67.7,151.2,151.2L600,448.8L600,448.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.5,407.5c0,48.6-39.4,88-88,88H292.5c-48.6,0-88-39.4-88-88V292.5c0-48.6,39.4-88,88-88h115c48.6,0,88,39.4,88,88 V407.5z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVersion11);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/version11.d84987ed636b35bd292086c839a52d15.svg";